<template>
  <div>
    <b-row>
      <b-col>
        <StocksCard :item-key="itemKey" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <output-amount-card :item-key="itemKey" />
      </b-col>
      <b-col>
        <price-card
          :item-key="itemKey"
          :is-required="priceRequired"
        />
      </b-col>
      <b-col>
        <warehouses-card :item-key="itemKey" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert
          v-if="stockData.max_amount && stockData.max_amount < dataItem[itemKey].entry_amount"
          show
          variant="warning"
        >
          <div class="alert-body text-center">
            <FeatherIcon icon="InfoIcon" /> Giriş Miktarı stok kartının girilen en yüksek tutar sınırını geçmektedir.

          </div>
        </b-alert>
      </b-col>
    </b-row>

  </div>
</template>
<script>
import {
  BRow, BCol, BAlert,
} from 'bootstrap-vue'
import PriceCard from '@/views/Admin/Stocks/Elements/QuickAdd/priceCard.vue'
import InvoiceNumberCard from '@/views/Admin/Stocks/Elements/QuickAdd/invoiceCard.vue'
import SuppliersCard from '@/views/Admin/Stocks/Elements/QuickAdd/suppliersCard.vue'
import WarehousesCard from '@/views/Admin/Stocks/Elements/QuickAdd/wareHousesCard.vue'
import StocksCard from '@/views/Admin/Stocks/Elements/QuickAdd/StocksCard.vue'
import OutputAmountCard from '@/views/Admin/Stocks/Elements/QuickAdd/output_amount.vue'

export default {
  name: 'QuickStockOutLineForm',
  components: {
    OutputAmountCard,
    BAlert,
    StocksCard,
    WarehousesCard,
    SuppliersCard,
    InvoiceNumberCard,
    PriceCard,
    BRow,
    BCol,
  },
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
    priceRequired: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['stockLines/dataItem']
    },
    stockData() {
      return this.$store.getters['stocks/dataItem']
    },
  },
}
</script>
